import ContentCopy from "@mui/icons-material/ContentCopy";
import InputAdornment from "@mui/material/InputAdornment";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import React from "react";
import styled from "styled-components";
import { AdminFormSection } from "./AdminFormShared.styles";
import { HXTextField, IconTextPair } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
export const CopyTextField = styled(HXTextField).attrs({
    disabled: true,
    InputProps: {
        startAdornment: React.createElement(InputAdornment, { position: "start" }, React.createElement(ContentCopy)),
    },
}) `
    & * {
        cursor: pointer;
    }
    background-color: transparent;
    & input.Mui-disabled {
        color: ${colors.black_main};
        -webkit-text-fill-color: ${colors.black_main};
        opacity: 1;
    }
`;
export const AdminAPIKeysResult = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const APICreationBanner = styled.div `
    ${IconTextPair}
    display: inline-flex;
    padding: 7px 12px;
    font-size: ${fontSizes.STANDARD};
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #fff6ee;
    border: 1px solid ${colors.accents_sunset};
    color: ${colors.black};
    & svg {
        font-size: ${fontSizes.LARGE} !important;
    }
`;
export const AdminAPIKeysForm = styled(AdminFormSection) ``;
